import React, { memo, useState, useEffect, useRef } from "react";

// ============== Components =============
import {
  Table,
  Form,
  Pagination,
  InputGroup,
  ListGroup,
  Toast,
  Spinner,
  Row,
  Col,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";

import {
  Divider,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";

import Select from 'react-select';
import API from "../../../../network/dashboardAPI";
import moment from "moment";
import { FORM_ACTIONS } from "../reducer/form";
import { CouponTemplateTypes } from "../helper";

const CouponForm = ({
  formState,
  formErrors,
  isRequesting,
  discountType,
  onBlur,
  onChange,
  onSelect,
  onChangeDis,
  showValidateDate,
  activeTab,
  dispatchForm
}) => {
  useEffect(() => {
    getSupplier();
    getCategories();
    // getProducts();
    getBrands();
    getSubCategory();
    getDefaultProducts();
    setCategoryList([]);
    setProductList([]);
    checkSelectedValue();
    if(activeTab === 0 || activeTab === 2){
      if(!formState.validity_type){
        dispatchForm({ 
          type: FORM_ACTIONS.UPDATE_FORM_FIELD, 
          payLoad: {
            name: "validity_type",
            value: "day"
          }
        });
      }
      if(!formState.valid_date || formState.valid_date === 0){
        dispatchForm({ 
          type: FORM_ACTIONS.UPDATE_FORM_FIELD, 
          payLoad: {
            name: "valid_date",
            value: 1
          }
        });
      }
    }
  }, []);
  const [supplierList, setSupplierList] = useState("");
  const [categoryList, setCategoryList] = useState("");
  const [productList, setProductList] = useState("");
  const [brandList, setBrandList] = useState("");
  const [subCategoryList, setsubCategoryList] = useState("");

  const categoryRef = useRef();
  const productRef = useRef();

  const [checked, setChecked] = useState(false);

  const checkSelectedValue = () => {
    if(formState.suppliers) {
      changeSupplier(formState.suppliers, 'suppliers');
    }

    if(formState.category) {
      changeCategory(formState.category, 'category');
    }

    if(formState.brand) {
      changeBrand(formState.brand, 'brand');
    }

    if(formState.sub_category) {
      changeSubCategory(formState.sub_category, 'sub_category');
    }
  };

  const getSupplier = (e) => {
    
    API.getSuppliers()
    .then((res) => res.json())
    .then((res) => {
      if(res.success) {
        const supplierObj = res.data;
        const newSupplierObj = [];
        supplierObj.forEach((item, index) => {
          newSupplierObj.push({
            value: item.store_user_id,
            label: item.store_users[0].first_name
          });
        });
        setSupplierList(newSupplierObj);
      }
    })
  };

  const getCategories = (e) => {
    API.getCouponMapCategoriesStoreUsers()
     .then((res) => res.json())
     .then((res) => {
      if(res.success) {
        const categoryObj = res.data;
        const newCategoryObj = [];
        categoryObj.forEach((item, index) => {
            if(item.list_categories.length != 0) {
              newCategoryObj.push({
                value: item.list_categories[0].cat_id,
                label: item.list_categories[0].name
              });
            }
        });
        setCategoryList(newCategoryObj);
      }
     });
  }

  const getBrands = (e) => {
    API.getBrands()
    .then((res) => res.json())
    .then((res) => {
      if(res.success) {
        const brandObj = res.data;
        const newBrandObj = [];
        brandObj.forEach((item, index) => {
          newBrandObj.push({
            value: item.brand_id,
            label: item.name
          });
        });
        setBrandList(newBrandObj);
      }
    });
  }

  const getSubCategory = (e) => {
    API.getSubCategory()
    .then((res) => res.json())
    .then((res) => {
      if(res.success) {
        const subCategoryObj = res.data;
        const newSubCategoryObj = [];
        subCategoryObj.forEach((item, index) => {
          newSubCategoryObj.push({
            value: item.sub_cat_id,
            label: item.list_sub_categories[0].name
          });
        });
        setsubCategoryList(newSubCategoryObj);
      }
    });
  }

  const changeSupplier = ((event, name) => {
    // categoryRef.current.select.clearValue();
    onSelect({
      name: name,
      value: event
    })
  });

  const changeCategory = ((event, name) => {
    // productRef.current.select.clearValue();
    onSelect({
      name: name,
      value: event
    })
  });

  const changeProduct  = ((event, name) => {
    onSelect({
      name: name,
      value: event
    })
  });

  const changeBrand = ((event, name) => {
    onSelect({
      name: name,
      value: event
    })
  });

  const changeSubCategory = ((event, name) => {
    onSelect({
      name: name,
      value: event
    })
  });

  const changeCouponTemplateType = ((event, name) => {
    onSelect({
      name: name,
      value: event
    })
  });

  const changeValidityType = ((event, name) => {
    onSelect({
      name: name,
      value: event
    })
  });
  // set time before call api
  let typingTimer; //timer identifier
  let doneTypingInterval = 1000; //time in ms (7.5 seconds)
  const findProduct = (value) => {
    if(value == "") {
      getDefaultProducts();
    } else {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function () {
        let query = {
          search: value
        }
        getProducts(query)
      }, doneTypingInterval);
    }
  };

  const getProducts = (data) => {
    let newproductObj = [];
    API.getCouponProduct(data)
      .then((res) => res.json())
      .then((res) => {
        if(res.success) {
          const productObj = res.data;
          productObj.forEach((item, index) => {
            newproductObj.push({
              value: item.item_id,
              label: item.name
            });
          });
          setProductList(newproductObj);
        }
      })
  }

  const getDefaultProducts = () => {
    let newProductDetailObj = [];
    API.getDefaultProduct()
      .then((res) => res.json())
      .then((res) => {
        if(res.success) {
          const productObj = res.data;
          productObj.forEach((item, index) => {
            newProductDetailObj.push({
              value: item.item_id,
              label: item.name
            });
          });
          setProductList(newProductDetailObj);
        }
      })
  }

  const handleChangeMultipleUses = (e) => {
    onChange(e);
    if (e.target.checked) {
      setChecked(true)
    } else {
      setChecked(false);
    }
  }

  useEffect(() => {
    if (formState.isOneTimeUse == false || formState.isOneTimeUse == 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, []);

  return <>
    <Form autoComplete="false">
      {showValidateDate && activeTab === 3 && <Row>
        <Col sm={12}>
          <Form.Group controlId="exampleForm.ControlSelect2">
            <Form.Label>Coupon Use For</Form.Label>
            <Form.Control 
              as="select" 
              value={formState.template_use_for}
              onChange={(e) => changeCouponTemplateType(e.target.value,"template_use_for")}
            >
              {CouponTemplateTypes.map((item) => <option value={item}>{item}</option>)}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>}
      <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              id="name"
              name="name"
              value={formState.name}
              isInvalid={formErrors?.name}
              placeholder="Name"
              disabled={isRequesting}
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              id="description"
              name="description"
              disabled={isRequesting}
              rows={3}
              value={formState.description}
              onChange={onChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Code</Form.Label>
            <Form.Control
              type="text"
              id="code"
              name="code"
              value={formState.code}
              isInvalid={formErrors?.code}
              placeholder="Code"
              disabled={isRequesting}
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.code}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group>
            <Form.Label>Quantity</Form.Label>
            <Form.Control
              type="number"
              id="amount"
              name="amount"
              value={formState.amount}
              isInvalid={formErrors?.amount}
              disabled={isRequesting}
              placeholder="Quantity"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.amount}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      {showValidateDate && <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Validity</Form.Label>
            <Form.Control
              type="Number"
              id="valid_date"
              name="valid_date"
              value={formState.valid_date}
              isInvalid={formErrors?.valid_date}
              disabled={isRequesting}
              placeholder="Valid Date"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.valid_date}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Label>Validity Type</Form.Label>
            <Form.Control 
              as="select" 
              value={formState.validity_type}
              onChange={(e) => changeValidityType(e.target.value,"validity_type")}
            >
              <option value={"day"}>Day</option>
              <option value={"month"}>Month</option>
              <option value={"year"}>Year</option>
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>}
      {!showValidateDate && <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              id="validFrom"
              name="validFrom"
              value={formState.validFrom}
              isInvalid={formErrors?.validFrom}
              disabled={isRequesting || showValidateDate}
              placeholder="Start Date"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.validFrom}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              id="validTo"
              name="validTo"
              value={formState.validTo}
              isInvalid={formErrors?.validTo}
              disabled={isRequesting || showValidateDate}
              placeholder="End Date"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.validTo}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>}

      <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Discount Type</Form.Label>
            <RadioGroup
              style={{
                borderRadius: "5px",
                height: "40px",
                padding: "0px 15px"
              }}
              aria-label="discountType"
              name="discountType"
              value={discountType}
              disabled={isRequesting}
              onChange={onChangeDis}
            >
              <Row>
                <Col sm={6}>
                  <FormControlLabel
                    value="FIXED_PRICE"
                    control={<Radio disabled={isRequesting} />}
                    label="Fixed Price"
                  />
                </Col>
                <Col sm={6}>
                  <FormControlLabel
                    value="PERCENTAGE"
                    control={<Radio disabled={isRequesting} />}
                    label="Percentage"
                  />
                  {}
                </Col>
              </Row>
            </RadioGroup>
          </Form.Group>
        </Col>
        {discountType === "FIXED_PRICE" ? (
          <Col sm={6}>
            <Form.Group>
              <Form.Label>Discount Fixed Price ($)</Form.Label>
              <Form.Control
                type="number"
                id="discountFixedPrice"
                name="discountFixedPrice"
                value={formState.discountFixedPrice}
                isInvalid={formErrors?.discountFixedPrice}
                disabled={isRequesting}
                placeholder="Discount Fixed Price"
                onChange={onChange}
                onBlur={onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors?.discountFixedPrice}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        ) : (
          <Col sm={6}>
            <Form.Group>
              <Form.Label>Discount Percentage (%)</Form.Label>
              <Form.Control
                type="number"
                id="discountPercentage"
                name="discountPercentage"
                value={formState.discountPercentage}
                isInvalid={formErrors?.discountPercentage}
                disabled={isRequesting}
                placeholder="Discount Percentage"
                onChange={onChange}
                onBlur={onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors?.discountPercentage}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        )}
      </Row>

      <Divider />
      <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Supplier</Form.Label>
            <Select
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#ced4da',
                }),
              }}
              name="supplier"
              value={formState.suppliers}
              isDisabled={isRequesting}
              options={supplierList}
              onChange={(e) => changeSupplier(e, 'suppliers')}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Brand</Form.Label>
            <Select
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#ced4da',
                }),
              }}
              name="brand"
              value={formState.brand}
              isDisabled={isRequesting}
              options={brandList}
              onChange={(e) => changeBrand(e, 'brand')}
            />
          </Form.Group>
        </Col>
        </Row>
        <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Category</Form.Label>
            <Select
            id="category"
            name="category"
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#ced4da',
                }),
              }}
              value={formState.category}
              isDisabled={isRequesting}
              options={categoryList}
              ref={categoryRef}
              onChange={(e) => changeCategory(e, 'category')}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Sub Category</Form.Label>
            <Select
              id="sub_category"
              name="sub_category"
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#ced4da',
                }),
              }}
              value={formState.sub_category}
              isDisabled={isRequesting}
              options={subCategoryList}
              onChange={(e) => changeSubCategory(e, 'sub_category')}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Product</Form.Label>
            <Select
              isMulti
              className="basic-multi-select"
              placeholder="Search Product by name..."
              classNamePrefix="select"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#ced4da',
                }),
              }}
              value={formState.products}
              isDisabled={isRequesting}
              onChange={(e) => changeProduct(e, 'products')}
              onInputChange={(e) => findProduct(e)}
              options={productList}
            />
          </Form.Group>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col sm="12" md="6">
        <Row>
        <Col sm={12}>
          <Form.Group>
            <Form.Label>Min Backet Price ($)</Form.Label>
            <Form.Control
              type="number"
              id="minimumBasketPrice"
              name="minimumBasketPrice"
              value={formState.minimumBasketPrice}
              isInvalid={formErrors?.minimumBasketPrice}
              disabled={isRequesting}
              placeholder="Min Backet Price"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.minimumBasketPrice}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check 
            type="checkbox" 
            label="Free Delivery"
            name="free_delivery"
            value={formState.free_delivery}
            checked={formState.free_delivery == '1' ? true : false}
            onChange={onChange}
           />
        </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
        <Form.Group>
            <Form.Label>Min Backet Value For Free Delivery ($)</Form.Label>
            <Form.Control
              type="number"
              id="free_delivery_value"
              name="free_delivery_bucket_value"
              value={formState.free_delivery_bucket_value}
              isInvalid={formErrors?.free_delivery_bucket_value}
              disabled={isRequesting}
              placeholder="Max Value for Free Delivery"
              onChange={onChange}
              onBlur={onBlur}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors?.free_delivery_bucket_value}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={6}></Col>
    </Row>
        </Col>
        <Col sm="12" md="6" className="mt-1">
          <Row>
            <Col sm={12}>
              <Form.Group className="mb-1">
                <Form.Check 
                  type="switch"
                  label="Multiple Uses"
                  id="isOneTimeUse"
                  name="isOneTimeUse"
                  value={formState.isOneTimeUse}
                  checked={checked}
                  onChange={(e) => handleChangeMultipleUses(e)}
                />
              </Form.Group>
            </Col>
            <Col sm={12}>
            {
                checked ?
                  <Form.Group>
                    <Form.Control 
                      type="number" 
                      id="used_qty"
                      name="used_qty"
                      value={formState.used_qty}
                      isInvalid={formErrors?.used_qty}
                      placeholder="Must be grater than 0"
                      onChange={onChange}
                      onBlur={onBlur}
                    />
                    <Form.Control.Feedback type="invalid">
                     {formErrors?.used_qty}
                    </Form.Control.Feedback>
                    {checked && formState.used_qty >= 1 ?  <span className="text-muted">x { formState.used_qty ? formState.used_qty : 0 } per user</span> : null }
                  </Form.Group> : null
              }
            </Col>
          </Row>
      </Col>
    </Row>
    </Form>
    </>;
};

export default memo(CouponForm);
